<div
  class="animation-host"
  [style.aspect-ratio]="size().width + ' / ' + size().height"
  [attr.data-animation]="animation() || null"
>
  @if (definition(); as def) {
    <ng-container [ngComponentOutlet]="def.component" [ngComponentOutletInputs]="componentInputs()" />
  } @else {
    <div class="animation-host__placeholder" aria-hidden="true">
      @if (animation()) {
        <span>Unknown animation: {{ animation() }}</span>
      } @else {
        <span>Select an animation</span>
      }
    </div>
  }
</div>
